export default "__VITE_PUBLIC_ASSET__5b483984__"